"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressMatchWrapper$ = exports.AddressMatchWrapper$outboundSchema = exports.AddressMatchWrapper$inboundSchema = void 0;
exports.addressMatchWrapperToJSON = addressMatchWrapperToJSON;
exports.addressMatchWrapperFromJSON = addressMatchWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const addressmatchmeta_js_1 = require("./addressmatchmeta.js");
const property_js_1 = require("./property.js");
/** @internal */
exports.AddressMatchWrapper$inboundSchema = z.object({
    attributes: property_js_1.Property$inboundSchema,
    id: z.string(),
    meta: addressmatchmeta_js_1.AddressMatchMeta$inboundSchema,
    type: z.literal("property").default("property").optional(),
});
/** @internal */
exports.AddressMatchWrapper$outboundSchema = z.object({
    attributes: property_js_1.Property$outboundSchema,
    id: z.string(),
    meta: addressmatchmeta_js_1.AddressMatchMeta$outboundSchema,
    type: z.literal("property").default("property"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AddressMatchWrapper$;
(function (AddressMatchWrapper$) {
    /** @deprecated use `AddressMatchWrapper$inboundSchema` instead. */
    AddressMatchWrapper$.inboundSchema = exports.AddressMatchWrapper$inboundSchema;
    /** @deprecated use `AddressMatchWrapper$outboundSchema` instead. */
    AddressMatchWrapper$.outboundSchema = exports.AddressMatchWrapper$outboundSchema;
})(AddressMatchWrapper$ || (exports.AddressMatchWrapper$ = AddressMatchWrapper$ = {}));
function addressMatchWrapperToJSON(addressMatchWrapper) {
    return JSON.stringify(exports.AddressMatchWrapper$outboundSchema.parse(addressMatchWrapper));
}
function addressMatchWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AddressMatchWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AddressMatchWrapper' from JSON`);
}
//# sourceMappingURL=addressmatchwrapper.js.map